import { useCallback, useMemo, useState } from 'react';
import { useTransactionAdder } from '../state/transactions/hooks';
import { useDoUpdate, useOnchainInteractions } from './useOnchain';
import { ButtonState } from '../components/InteractionButton';
import { formatAmount } from '../utils/format';
import { AirdropData, Contract } from 'impermax-sdk';


export default function useClaimAirdrop(airdropData: AirdropData, merkleDistributor: Contract): [ButtonState, () => Promise<void>] {
  const onchainInteractions = useOnchainInteractions();
  const doUpdate = useDoUpdate();
  const addTransaction = useTransactionAdder();
  const [pending, setPending] = useState<boolean>(false);

  const summary = airdropData && airdropData.amount && `Claim ${formatAmount(parseFloat(airdropData.amount.toString()) / 1e18)}`;
  
  const claimAirdropState: ButtonState = useMemo(() => {
    if (pending) return ButtonState.Pending;
    return ButtonState.Ready;
  }, [pending]);

  const claimAirdrop = useCallback(async (): Promise<void> => {
    if (claimAirdropState !== ButtonState.Ready) return;
    setPending(true);
    try {
      await onchainInteractions.claimAirdrop(airdropData, merkleDistributor, (hash: string) => {
        addTransaction({ hash }, { summary });
      });
      doUpdate();
    }
    finally {
      setPending(false);
    }
  }, [claimAirdropState, airdropData, addTransaction]);

  return [claimAirdropState, claimAirdrop];
}
